<template>
  <v-navigation-drawer v-model="drawer" app clipped>
    <v-expansion-panels :multiple="true" v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header>Admin</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list dense>
            <v-list-item link to="/admin/dashboard">
              <v-list-item-action>
                <v-icon>mdi-blur-radial</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/admin/users">
              <v-list-item-action>
                <v-icon>mdi-account-multiple</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Users</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/admin/projects">
              <v-list-item-action>
                <v-icon>mdi-folder-multiple-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Projects</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/admin/groups">
              <v-list-item-action>
                <v-icon>mdi-account-multiple</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Groups</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/admin/exercises">
              <v-list-item-action>
                <v-icon>mdi-pencil</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Exercises</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>Exercises</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list dense>
            <v-list-item
              link
              :to="`/admin/${item.slug}`"
              v-for="item in exercises"
              :key="`admin-${item.id}`"
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>User</v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list dense>
            <v-list-item link to="/users/dashboard">
              <v-list-item-action>
                <v-icon>mdi-blur-radial</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- <v-list-item
        link
        :to="`/exercises/${item.slug}`"
        v-for="item in currentExercises"
        :key="`user-${item.id}`"
      >
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
  </v-navigation-drawer>
</template>

<script>
// @ is an alias to /src
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
export default {
  name: "SidebarAdmin",
  data() {
    return {
      exercises: null,
      drawer: this.value,
      panel: [0],
    };
  },
  props: {
    value: Boolean,
  },
  mounted() {
    this.getExercises();
  },
  computed: {
    ...mapState(["currentUser", "currentProject", "currentExercises"]),
  },
  watch: {
    value: {
      handler: function(val) {
        this.drawer = val;
      },
      deep: true,
    },
  },
  methods: {
    getExercises() {
      fb.exercisesCollection
        .get()
        .then((docs) => {
          let items = [];
          docs.forEach((docs) => {
            let doc = docs.data();
            items.push(doc);
          });
          this.exercises = items;
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
  },
};
</script>
